// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import lodash from 'lodash'
import VueLodash from 'vue-lodash/dist/vue-lodash.min'

Vue.use(VueLodash, lodash)

import Card from './components/Elements/Card/Card.vue'

Vue.component('Card', Card)

import Chartkick from 'chartkick'
import VueChartkick from 'vue-chartkick'
import Highcharts from 'highcharts'

window.Highcharts = Highcharts
Vue.use(VueChartkick, { Chartkick })

Vue.config.productionTip = false

try {
    window.$ = window.jQuery = require('jquery');
    require('bootstrap-sass');
} catch (e) {}

require('es6-promise').polyfill()
    //require('font-awesome/css/font-awesome.css')

var numeral = require('numeral')

numeral.register('locale', 'de', {
    delimiters: {
        thousands: '.',
        decimal: ','
    },
    abbreviations: {
        thousand: 'k',
        million: 'm',
        billion: 'b',
        trillion: 't'
    },
    ordinal: function(number) {
        return number;
    },
    currency: {
        symbol: '€'
    }
});

Vue.filter('myCurrency', function(value) {
    numeral.locale('de')
    return numeral(value).format()
})

// Some Config
Vue.prototype.$serviceurl = 'https://crm.hennig-fahrzeugteile.de:16120/'

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js